import { getValueFromPath } from "../../IndexedDb/util.js";
import { formatNameFromVehicleObj } from "../../utils/utils";
import { GET_SIZE_AND_WEIGHT_VEHICLES } from "../SizeAndWeightFrame/Query/GetSizeAndWeightVehicles";
import { GET_TICKETS } from "./queries";

export const vehicleHasTickets = async (vehicle, incident, user, client) => {
  let incidentTickets = incident.incidentTickets;
  let res = { hasAssociation: true, associationErrors: [] };
  if (!user.id) {
    res.associationErrors.push("user not found");
    res.hasAssociation = true;
    return res;
  }
  if (!vehicle.id && !vehicle.uuid) {
    res.associationErrors.push("Vehicle not passed to vehicleHasTickets");
    res.hasAssociation = true;
    return res;
  }
  if (!incident.id) {
    res.associationErrors.push("Incident not found");
    res.hasAssociation = true;
    return res;
  }

  if (!incidentTickets) {
    try {
      const { data } = await client.query({
        query: GET_TICKETS,
        variables: { incidentId: incident.id, originatorId: user.id },
        context: { timeout: 60000 },
        fetchPolicy: "network-only",
      });
      incidentTickets = getValueFromPath(data, "getTickets");
    } catch (err) {
      res.associationErrors.push("Error getting tickets", err);
      res.hasAssociation = true;
      return res;
    }
  }

  const vehicleHasTickets = incidentTickets.some(
    ticket => ticket?.vehicle?.id === vehicle.id
  );

  if (vehicleHasTickets) {
    const vehicleName = formatNameFromVehicleObj(vehicle);
    res.hasAssociation = true;
    if (vehicleHasTickets) {
      res.associationErrors.push(
        `You cannot remove ${vehicleName} from the incident because that vehicle is associated with a VCVC.`
      );
    }
  } else {
    res.hasAssociation = false;
  }
  return res;
};

export const vehicleHasSwAssociation = async (
  vehicle,
  incident,
  user,
  client
) => {
  let sw = incident?.sizeAndWeight;
  let res = { hasSwAssociation: true, swAssociationErrors: [] };

  if (!user.id) {
    res.swAssociationErrors.push("user not found");
    res.hasSwAssociation = true;
    return res;
  }
  if (!vehicle.id) {
    res.swAssociationErrors.push(
      "Vehicle not passed to vehicleHasSwAssociation"
    );
    res.hasSwAssociation = true;
    return res;
  }
  if (!incident.id) {
    res.swAssociationErrors.push("Incident not found");
    res.hasSwAssociation = true;
    return res;
  }
  try {
    const { data } = await client.query({
      query: GET_SIZE_AND_WEIGHT_VEHICLES,
      variables: { incidentId: incident.id, originatorId: user.id },
      context: { timeout: 60000 },
      fetchPolicy: "network-only",
    });
    sw = getValueFromPath(data, "initialCallInfo.sizeAndWeight");
  } catch (err) {
    res.swAssociationErrors.push("Error getting the size and weight ID", err);
    res.hasSwAssociation = true;
    return res;
  }

  //check if the vehicle.id is either the powerUnit.id or any of the trailer.id's in trailers
  const vehicleHasSwAssociation =
    sw?.powerUnit?.id === vehicle.id ||
    sw?.trailers?.some(trailer => trailer?.id === vehicle.id);

  if (vehicleHasSwAssociation) {
    const vehicleName = formatNameFromVehicleObj(vehicle);
    res.hasSwAssociation = true;
    res.swAssociationErrors.push(
      `You cannot remove ${vehicleName} from the incident because that vehicle has an association in the Size and Weight frame.`
    );
  } else {
    res.hasSwAssociation = false;
  }

  return res;
};
